const KEY = "miltroo_pwa_sid";

export function pwaSessionId() {
  try {
    let s = sessionStorage.getItem(KEY);
    if (!s) {
      s = Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem(KEY, s);
    }
    return s;
  } catch { return "nosession"; }
}

export const isStandalone = () => {
  try { return window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true; } catch { return false; }
};

export function trackAppEvent(event, extra = {}) {
  try {
    const payload = JSON.stringify({
      event, session_id: pwaSessionId(), path: window.location.pathname,
      device: window.innerWidth < 768 ? "mobile" : "desktop",
      standalone: isStandalone(), ...extra,
    });
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/app-pwa/event`;
    if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
    else fetch(url, { method: "POST", body: payload, headers: { "Content-Type": "application/json" }, keepalive: true });
  } catch { /* analytics must never break the app */ }
}
